import styled from 'styled-components'

import { getStateColor } from '@/presentation/utils'

export const Container = styled.div`
  width: 100%;
`

export const Label = styled.p`
  color: ${({ theme }) => theme.colors.neutralL5};
  margin-bottom: 12px;
  text-transform: uppercase;
  ${({ theme }) => theme.fonts.labelMD};
`

interface HelpMessageProps {
  error?: boolean
}

export const HelpMessage = styled.div<HelpMessageProps>`
  ${({ theme }) => theme.fonts.textMD}
  color: ${({ theme, error }) => (error ? theme?.colors?.error : theme?.colors?.neutralL5)};
  margin: 0;
  margin-top: 4px;
  height: auto;
`

interface UnitFieldInputContainerProps {
  size?: 'sm' | 'md' | 'lg'
}

export const UnitFieldInputContainer = styled.div<UnitFieldInputContainerProps>`
  cursor: text;
  position: relative;
  background-color: ${({ theme }) => theme.colors.secondary};
  height: ${({ size }) => {
    if (size === 'sm') return '40px'
    if (size === 'md') return '48px'
    if (size === 'lg') return '64px'
  }};
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;

  & .unit-field-input {
    margin-right: 48px;

    &[type='number']::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    &[type='number'] {
      -moz-appearance: textfield;
      appearance: textfield;
    }
  }
`

interface ButtonProps {
  role: 'increment' | 'decrement' | 'switch'
}

export const Button = styled.button<ButtonProps & UnitFieldInputContainerProps>`
  border: none;
  position: absolute;
  ${({ role }) => (role === 'decrement' ? 'left: 4px;' : 'right: 4px;')}
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 56px;
  /* min-width: 38px; */
  min-width: ${({ size }) => {
    if (size === 'sm') return '32px'
    if (size === 'md') return '38px'
    if (size === 'lg') return '50px'
  }};
  /* max-height: 38px; */
  max-height: ${({ size }) => {
    if (size === 'sm') return '32px'
    if (size === 'md') return '38px'
    if (size === 'lg') return '50px'
  }};
  height: 100%;
  border-radius: 8px;
  padding: 1px 4px;
  background-color: ${({ theme }) => theme.colors.secondaryL1};
  &:not(:disabled) {
    cursor: pointer;
  }

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => getStateColor(theme.colors.secondaryL1, 'hover')};
  }

  &:active:not(:disabled) {
    background-color: ${({ theme }) => getStateColor(theme.colors.secondaryL1, 'pressed')};
  }

  &:disabled {
    opacity: 0.5;
  }
`

export const ButtonText = styled.p<UnitFieldInputContainerProps>`
  ${({ theme, size }) =>
    size === 'lg' ? theme.fonts.infoLG : size === 'md' ? theme.fonts.infoMD : theme.fonts.infoSM};
  color: ${({ theme }) => theme.colors.neutralL5};
`
